import React, { useEffect } from 'react';
import { Breadcrumb, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { RBHAlert, RBHBox, RBHError, RBHImage, RBHTable, RBHText } from '../../../shared/components';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { httpCreators, useLoadingSelector } from 'rbh-merchant-core';
import { AlertData, DEVICE_STATE_KEY, deviceStateSelector } from './redux/device-reducer';
import { deviceSagas } from './redux/device-saga';
import { DeviceService } from './redux/device-service';
import { DEVICE_REQUEST_ID_LIST } from './redux/device-constant';
import styleText from '../../../shared/components/rbh-text/styles';
import { mainCreators } from '../../main-action';
import { MAIN_STATE_KEY } from '../../main-reducer';
import stylesDevice from '../DeviceManagement/styles';
import { generalCreators } from '../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../redux/general/general-constant';
import styleImage from '../../../shared/components/rbh-image/styles';
import { deviceCreators } from './redux/device-action';
import metrics from '../../../shared/theme/metrics';
import styles from './styles';
import { Images } from '../../../shared/theme';
import { UtilHelper } from '../../../shared/helpers/utility';
import moment from 'moment';

export const DeviceManagementScreen: React.FC<Props> = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(deviceStateSelector(DEVICE_STATE_KEY.DEVICE_LIST)) as [];
  const maxDeviceLogin = useSelector(deviceStateSelector(DEVICE_STATE_KEY.MAX_DEVICE_LOGIN)) as string;
  const alertSuccessData = useSelector(deviceStateSelector(DEVICE_STATE_KEY.ALERT_SUCCESS)) as AlertData;
  const loading = useLoadingSelector(DEVICE_REQUEST_ID_LIST.POST_DEVICE_LIST);

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(deviceCreators.callDeviceListTnc());
  };

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 0));
    resetReload();
  }, []);

  const pushTo = (path: string) => {
    history.push(path);
  };

  const onLogout = (value: number, deviceDisplay: string) => {
    dispatch(httpCreators.request({
      id: DEVICE_REQUEST_ID_LIST.POST_FORCE_LOGOUT,
      sagaHandler: deviceSagas.postForceLogoutHandler,
      callbackParams: { resetReload, deviceDisplay },
      service: DeviceService.postForceLogout,
      serviceParams: { instantLoginId: value }
    }));
  };

  const onConfirm = (value: number, deviceDisplay: string) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => onLogout(value, deviceDisplay),
      modalImageId: 'confirm-forceLogout-img-alert',
      modalTitle: 'main.deviceManagement.logout.modal.title',
      modalTitleId: 'popupDeviceLogoutTitle-text',
      valueText: 'main.deviceManagement.logout.modal.value',
      valueId: 'deviceDisplay-text',
      values: { deviceDisplay },
      modalContent: 'main.deviceManagement.logout.modal.content',
      modalContentId: 'popupDeviceLogoutContent-text',
      onCancelTextId: 'cancelDeviceLogoutBtn-text',
      onOkTextId: 'confirmDeviceLogoutBtn-text',
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const columns = [
    {
      width: metrics.tableHeader.width460,
      title: <FormattedMessage id={'main.deviceManagement.table.device'} />,
      align: 'left',
      dataIndex: 'instantLoginDeviceDisplay',
      render: (value: any, all: any, index: number) => {
        const id = `instantLoginDeviceDisplay-${index}`;
        return (
          <RBHBox id={id} data-testid={id}>
            {value}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width325,
      title: <FormattedMessage id={'main.deviceManagement.table.dateTimeLogin'} />,
      align: 'left',
      dataIndex: 'lastLoginDateTime',
      render: (value: any, all: any, index: number) => {
        const id = `loginDatetime-${index}`;
        return (
          <RBHBox id={id} data-testid={id}>
            {UtilHelper.formatThaiDate(value) + ', ' + moment(value).format('HH:mm')}
          </RBHBox>
        );
      }
    },
    {
      render: (value: any, all: any, index: number) => {
        const id = `forceLogout-${index}`;
        return (
          <RBHBox>
            <RBHText style={styles.logoutText} id={id} data-testid={id}
              text={'main.deviceManagement.logout.text'}
              onClick={() => onConfirm(all.instantLoginId, all.instantLoginDeviceDisplay)} />
          </RBHBox>
        );
      }
    }
  ];

  const AlertBar = () => {
    if (alertSuccessData?.isVisible) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert
            type={'success'}
            text={'main.deviceManagement.alert.success'}
            values={alertSuccessData?.translationValues}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(deviceCreators.setDeviceState(DEVICE_STATE_KEY.ALERT_SUCCESS, {
                isVisible: false
              }));
            }}
          />
          <br />
        </RBHBox>
      );
    } else {
      return null;
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'homepage-breadcrumb'} id={'homepage-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => {
                pushTo('/main');
              }}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'deviceManagement-breadcrumb'} id={'deviceManagement-breadcrumb'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.deviceManagement.breadcrumb.text'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const HeaderRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText style={styleText.headerText} text={'main.deviceManagement.header.text'}
          data-testid={'deviceManagement-header'} id={'deviceManagement-header'} />
      </RBHBox>
    );
  };

  const SubheaderRender = () => {
    if (data !== undefined) {
      return (
        <RBHBox style={styles.subTitleText} data-testid={'deviceManagement-subtitle'} id={'deviceManagement-subtitle'}>
          <FormattedMessage id={'main.deviceManagement.subtitle.text'} values={{ maxDeviceLogin }} />
        </RBHBox>
      );
    } else {
      return null;
    }
  };

  const TableRender = () => {
    return (
      <RBHTable
        rowKey={(record: { instantLoginId: any; }) => record.instantLoginId}
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={false}
      >
      </RBHTable>
    );
  };

  const EmptyDeviceList = () => {
    return (
      <RBHBox style={styles.emptyWrapper}>
        <Row style={{ justifyContent: 'center' }}>
          <RBHImage style={{ ...styleImage.icon250 }} src={Images.emptyState}
            data-testid={'emptyDeviceList-img'} id={'emptyDeviceList-img'} />
        </Row>
        <RBHText style={styles.emptyText} text={'main.deviceManagement.notfound.text'}
          data-testid={'deviceManagement-notfound'} id={'deviceManagement-notfound'} />
      </RBHBox>
    );
  };

  const MainContent = () => {
    return (
      <RBHBox>
        {data === undefined
          ? <RBHError onOk={() => resetReload()} />
          : data === null
            ? <EmptyDeviceList />
            : <RBHBox style={stylesDevice.defaultContent}>
              <TableRender />
            </RBHBox>
        }
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      <AlertBar />
      <BreadcrumbRender />
      {loading
        ? null
        : <RBHBox>
          <HeaderRender />
          <SubheaderRender />
          <MainContent />
        </RBHBox>
      }
    </RBHBox>
  );
};

type Props = {};
